export function enumKeys<EnumType>(_enum: { [key: string]: string }) {
  return Object.keys(_enum).map((key) => _enum[key]) as EnumType[]
}
